<template>
  <div>
    <p class="fonte">
      <b>Fonte:</b>
      {{ ' e-SUS PEC, ' + ultimaAtualizacao }}
      <span v-if="texto" v-b-tooltip.hover :title="text" class="icon-tooltip">
        <i class="icofont-info-circle"></i>
      </span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    texto: {
      type: String,
      default: '',
    },
    data: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  mounted() {},
  computed: {
    text() {
      let date = this.ultimaAtualizacao.split('/').reverse().join('-')
      let dateSplit = date.split('-')
      let day = dateSplit[2]
      let month = dateSplit[1]
      let year = dateSplit[0]
      let date2 = new Date(year, month - 1, day)
      const date3 = `${date2.getDate() - 1}/${month}/${year}`
      return `${this.texto} ${date3}`
    },
    ultimaAtualizacao() {
      let date = ''
      if (this.$store.getters['getUltimaAtualizacao'] !== null) {
        date = this.$store.getters['getUltimaAtualizacao']
      }
      return date
    },
  },
  methods: {},
}
</script>

<style lang=""></style>
